import { Component, EventEmitter, Output, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { GlobalsService } from '../../shared/services/globals.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { GItem } from '../../shared/models/GItem';
import { CommonValues } from '../../shared/static/CommonValues';
import { AppClaims } from '../../shared/models/AppClaims';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dispatch-change-status-dialog',
    templateUrl: './dispatch-change-status-dialog.component.html',
    styleUrls: ['./dispatch-change-status-dialog.component.scss'],
    standalone: false
})
export class DispatchChangeStatusDialogComponent implements OnDestroy, OnInit {

    constructor(private globals: GlobalsService, private authService: CmProAuthService, private qry_rd: DQOIReferenceDataQuery) {

    }
    referenceData: DQOIReferenceData;

    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    active: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    dispatchStatusId: string;
    destroySub = new Subscription();

    code: string;
    rights: AppClaims = new AppClaims();
    @Input() title: string;
    @Input() showAllStatus: Boolean = false;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    includedStatusIds: string[] = [
        CommonValues.Dispatch_NeedsParts,
        CommonValues.Dispatch_WH_ShopDuties,
        CommonValues.Dispatch_FollowUp,
        CommonValues.Dispatch_ForReview_ManagerApproval,
        CommonValues.Dispatch_ForConstructionReview,
        CommonValues.Dispatch_DSP_Refer_Tracking_Needed,
        CommonValues.Dispatch_Quote_Needs_Approval,
        CommonValues.Dispatch_CUST_Acct_Mgr_Approval,
        CommonValues.Dispatch_Parts_Rejected_Quote
    ]
    statusList: GItem[] = [];

    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };

    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
        this.destroySub?.unsubscribe();
    }

    ngOnInit(): void {
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });
        this.destroySub.add( this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe());
        this.destroySub.add(this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        }));
    }

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;

    }

    ok() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.ok, data: this.dispatchStatusId, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.active = true;
        this.statusList = [];
        var self = this;
        if (!this.showAllStatus) {
            if (this.rights.SetDispatchToReadyForBilling) {
                this.includedStatusIds.push(CommonValues.Dispatch_ReadyForBilling)
            }
            this.referenceData.dispatchStatus.forEach(item => {
                var lu = item.value
                if (self.includedStatusIds.lastIndexOf(lu) >= 0) {
                    self.statusList.push(item);
                }
            });
        }
        else {
            this.referenceData.dispatchStatus.forEach(item => {
                var lu = item.value

                    self.statusList.push(item);

            }); }
    }
}

